import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ApprovalItemModel,
  ApprovalItemMutationInput,
  ApprovalItemUpdateInput,
} from './model';

export function useCreateApprovalItem(
  options?: UseMutationOptions<
    ApiResult<ApprovalItemModel>,
    ApiError,
    ApprovalItemMutationInput
  >,
): UseMutationResult<
  ApiResult<ApprovalItemModel>,
  ApiError,
  ApprovalItemMutationInput
> {
  return useMutation<
    ApiResult<ApprovalItemModel>,
    ApiError,
    ApprovalItemMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'approval-items',
      method: 'POST',
      classType: ApprovalItemModel,
      body,
    });
  }, options);
}

export function useUpdateApprovalItem(
  options?: UseMutationOptions<
    ApiResult<ApprovalItemModel>,
    ApiError,
    ApprovalItemUpdateInput
  >,
): UseMutationResult<
  ApiResult<ApprovalItemModel>,
  ApiError,
  ApprovalItemUpdateInput
> {
  return useMutation<
    ApiResult<ApprovalItemModel>,
    ApiError,
    ApprovalItemUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `approval-items/update-approval-verdict/${body.approvalId}`,
      method: 'PATCH',
      classType: ApprovalItemModel,
      body: body.body,
    });
  }, options);
}
